import Grid from "@mui/material/Grid";
import {Item} from "../CharStyled";
import TextField from "@mui/material/TextField";
import React from "react";
import {useSignals} from "@preact/signals-react/runtime";
import {s_char} from "../../_signals/s_char";
import updChar from "../../_sig_api/updChar";
import {displaySchwellehModNSC} from "../../_helper/displaySchwelleModNSC";

export default function CharTOTNSC() {
    useSignals()
    return <Grid item sm={2} xs={4}>
        <Item>
            <TextField InputLabelProps={{shrink: true}}
                       onChange={e => updChar([{k: 'tot', v: parseInt(e.target.value)}])}
                       style={{marginLeft: 8, maxWidth: 80}}
                       value={s_char.value.tot}
                       variant="standard" type="number" label="Todchw." id="tot"
                       name="tot"/>
            {displaySchwellehModNSC('tot')}
        </Item>
    </Grid>;
}